module.exports = __webpack_public_path__ + "static/img/headerBannerHonor.a9bb3179.png";